import {Component, OnInit} from '@angular/core';
import {TreeNode} from "primeng/api";
import {ProareaService} from "../../../../services/proarea.service";
import {ToastService} from "../../../../services/toast.service";
import {ProAreaVariavel} from "../../../../types/ProAreaVariavel.type";
import {ProintegracaoService} from "../../../../services/prointegracao.service";

@Component({
  selector: 'app-variaveis',
  templateUrl: './provariaveis.component.html',
  styleUrl: './provariaveis.component.css'
})
export class ProvariaveisComponent implements OnInit {

  areas!: TreeNode[]
  loading: boolean = false;

  selecionarVariaveis: ProAreaVariavel[] = []

  constructor(private proAreaService: ProareaService, private toastService: ToastService, private integracaoService: ProintegracaoService) {
  }

  ngOnInit() {

    this.buscarAreas()

  }

  buscarAreas() {
    this.proAreaService.getAreaComVariaveis().subscribe({
      next: data => {
        this.selecionarVariaveis = data;

        this.getAreas().then((data) => (this.areas = data));

      },
      error: err => {
        this.toastService.erro("Erro", "Erro ao buscar as variaveis")
      }
    })
  }


  getAreas() {
    return Promise.resolve(this.selecionarVariaveis.map(area => ({

      key: `${area.id}`,
      label: `${area.codigo} - ${area.descricao}`,
      children: area.fontes?.map((fonte) => ({
        key: `${area.id}-${fonte.id}`,
        label: `${fonte.codigo} - ${fonte.descricao}`,
        children: fonte.variaveis?.map((variaveis) => ({
          key: `${area.id}-${fonte.id}-${variaveis.id}`,
          icon: 'pi pi-fw pi-cog',
          label: `${variaveis.codigo} - ${variaveis.descricao}`,
        }))
      }))
    })));
  }


  sincronizarCadastros() {

    this.loading = true;

    this.integracaoService.sincronizarCadastros().subscribe({
      next: data => {
        this.toastService.sucesso("Sucesso", "Sincronização finalizada")
        this.buscarAreas()
      },
      error: err => {
        this.toastService.erro("Erro", "Erro ao sincronizar: " + err.error.message);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

}
